import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import PageLayout from "@/components/layout/PageLayout";
import CompactQuoteButton from "@/components/CompactQuoteButton";
import Cities from "@/components/sections/Cities";

const FAQPage = () => {
  return (
    <PageLayout>
      <section className="py-6 sm:py-8 px-4">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-8">
            <Badge variant="outline" className="mb-2">Help Center</Badge>
            <h1 className="text-3xl sm:text-4xl font-bold mb-4">Frequently Asked Questions</h1>
            <p className="text-neutral mb-8">Find answers to common questions about our insurance services</p>
            <div className="flex justify-center mb-8">
              <CompactQuoteButton />
            </div>
          </div>

          <Accordion type="single" collapsible className="bg-white rounded-lg shadow-sm">
            <AccordionItem value="item-1" className="px-4 border-b border-purple-100">
              <AccordionTrigger className="text-left">What types of insurance do you offer?</AccordionTrigger>
              <AccordionContent className="text-neutral">
                We offer a comprehensive range of insurance products including auto, home, business, and life insurance. Each policy can be customized to meet your specific needs and budget.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-2" className="px-4 border-b border-purple-100">
              <AccordionTrigger className="text-left">How do I file a claim?</AccordionTrigger>
              <AccordionContent className="text-neutral">
                Filing a claim is simple. You can either call our 24/7 claims hotline, use our online claims portal, or contact your local agent directly. We'll guide you through the process and ensure your claim is handled promptly.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-3" className="px-4 border-b border-purple-100">
              <AccordionTrigger className="text-left">How can I get a quote?</AccordionTrigger>
              <AccordionContent className="text-neutral">
                You can get a quote in several ways: use our online quote tool, call us directly, or visit one of our local offices. We'll need some basic information about what you want to insure to provide you with an accurate quote.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-4" className="px-4 border-b border-purple-100">
              <AccordionTrigger className="text-left">What factors affect my insurance premium?</AccordionTrigger>
              <AccordionContent className="text-neutral">
                Insurance premiums are calculated based on several factors including your coverage needs, location, claims history, and specific risk factors related to what you're insuring. For example, auto insurance may consider your driving record and the type of vehicle.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-5" className="px-4 border-b border-purple-100">
              <AccordionTrigger className="text-left">Are there any discounts available?</AccordionTrigger>
              <AccordionContent className="text-neutral">
                Yes, we offer various discounts including multi-policy discounts, safe driver discounts, good student discounts, and more. Contact our team to learn about all available discounts you may qualify for.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-6" className="px-4 border-b border-purple-100">
              <AccordionTrigger className="text-left">What is covered under home insurance?</AccordionTrigger>
              <AccordionContent className="text-neutral">
                Home insurance typically covers damage to your house and personal property from events like fire, theft, and natural disasters. It also includes liability protection if someone is injured on your property.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-7" className="px-4 border-b border-purple-100">
              <AccordionTrigger className="text-left">Do you offer business interruption insurance?</AccordionTrigger>
              <AccordionContent className="text-neutral">
                Yes, our business insurance policies can include business interruption coverage, which helps replace lost income if your business has to temporarily close due to a covered loss.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-8" className="px-4 border-b border-purple-100">
              <AccordionTrigger className="text-left">What's the difference between term and whole life insurance?</AccordionTrigger>
              <AccordionContent className="text-neutral">
                Term life insurance provides coverage for a specific period, while whole life insurance provides lifetime coverage and includes a savings component that builds cash value over time.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-9" className="px-4 border-b border-purple-100">
              <AccordionTrigger className="text-left">How quickly can I get coverage?</AccordionTrigger>
              <AccordionContent className="text-neutral">
                Many of our policies can begin coverage immediately after approval and payment. The exact timing depends on the type of insurance and any required inspections or documentation.
              </AccordionContent>
            </AccordionItem>

            <AccordionItem value="item-10" className="px-4 border-b border-purple-100">
              <AccordionTrigger className="text-left">Can I manage my policy online?</AccordionTrigger>
              <AccordionContent className="text-neutral">
                Yes, our online portal allows you to view your policy details, make payments, file claims, and request changes to your coverage 24/7.
              </AccordionContent>
            </AccordionItem>
          </Accordion>
        </div>
      </section>
      <Cities />
    </PageLayout>
  );
};

export default FAQPage;